import { put, take } from "redux-saga/effects";

import { consoleLogError } from "./console";

const ACTION_TYPE_COMPLETE_COMMON_PROCESS = "common-process/";
const getActionTypeCommonProcess = (process) => ACTION_TYPE_COMPLETE_COMMON_PROCESS + process;
const actionCompleteCommonProcess = (process, data) => {
  return {
    type: getActionTypeCommonProcess(process),
    data
  };
};
// Use this function to enhance a generator function to return its existing call if the same args.
const activeProcesses = new Set();

export function* withTakePreviousCallIfSameParams(fnGenerator, ...args) {
  const process = fnGenerator.name + args.join("");

  if (activeProcesses.has(process)) {
    const action = yield take(getActionTypeCommonProcess(process));
    return action.data;
  }

  activeProcesses.add(process);

  let result;

  try {
    result = yield fnGenerator(...args);
  } catch (e) {
    consoleLogError("[withTakePreviousCallIfSameParams]", "Error", e);
  }

  yield put(actionCompleteCommonProcess(process, result));
  activeProcesses.delete(process);
  return result;
}
